module["exports"] = [
  "#{street_name} #{building_number}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/street_address.js
// module id = 851
// module chunks = 0